import styled from 'styled-components';
import {device} from 'styled/device';
import Link from 'components/common/Link';

export const ModalSheetContainer = styled.div`
  padding: 0 24px;

  @media (min-width: ${device.mobileXL}) {
    padding: 0;
  }
`;

export const WhyDataRequiredText = styled.span`
  margin-bottom: 15px;
  color: ${props =>
    props.theme.hasTemplate
      ? props.theme.colors.branding.fontPrimary
      : props.theme.colors.$p10};
  display: block;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: left;
`;

export const ViewPrivacyPolicyLink = styled(Link)`
  display: block;
  margin: 48px auto 20px;
  text-align: center;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.15px;
  color: ${props => props.theme.colors.buttons.textButton};
`;
